import React from "react"

const Hero: React.FC = (): JSX.Element => {
  return (
    <section className="bg-white py-6">
      <div className="container mx-auto px-4">
        <h1 className="text-2xl font-bold text-black mb-3 text-center">
          CHÍNH SÁCH BẢO MẬT THÔNG TIN
        </h1>
        <p className="text-sm text-gray-600 text-center mb-4">
          Ngày cập nhật gần nhất: {new Date().toLocaleDateString("vi-VN")}
        </p>
      </div>
    </section>
  )
}

export default Hero
